import type { MeterData, RosettaSDK, RosettaUser, Tracking } from "@product/rosetta-sdk";
import type { AsyncState } from "@react-hookz/web";
import { atom } from "jotai";

export type AppSettings = {
  isShowPremiumPromo?: boolean;
  litePaywallTimeFrame?: number;
  oldArticleTimeframe?: number;
  paywallCampaignName?: string;
};

export type Rosetta = {
  appSettings?: AppSettings;
  contentServiceUserInfo?: {
    isSubscriptionEnabled: boolean;
  };
  hasIpAccess?: boolean;
  hasPianoExperienceExecuted?: boolean;
  hasScmpDigitalAccessRight?: boolean;
  hasScmpLiteAccessRight?: boolean;
  hasScmpPlusAccessRight?: boolean;
  instance?: RosettaSDK;
  isScmpPlusSubscriber?: boolean;
  isScmpSubscriber?: boolean;
  meterData?: MeterData;
  tracking?: Tracking;
  user?: RosettaUser;
};

export const rosettaAtom = atom<AsyncState<Rosetta | undefined> | undefined>(undefined);
